import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "common-layout" }

import { ref, defineAsyncComponent, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { Roles, useCommonStore } from "@/store/CommonStore";
import { useUserStore } from "@/store/UserStore";

export default /*@__PURE__*/_defineComponent({
  __name: 'ConfiguracionView',
  setup(__props) {

// import { computed, onMounted, ref } from "vue";
// import { ElInput, ElTable, ElTableColumn } from "element-plus";
const router = useRouter();
const UserStore = useUserStore()
const CommonStore = useCommonStore()
const activeComponent = ref(""); // Estado para el componente activo
const userRoles = computed(() => {
  return UserStore.userRoles
});
// Función para cambiar el componente activo
const setActiveComponent = (componentName: string) => {
  activeComponent.value = componentName;
};

// Mapeo de componentes para la carga dinámica
const componentsMap = {
  ConfigurarTareas: defineAsyncComponent(
    () => import("../components/ConfigurarTareas.vue")
  ),
  ConfigurarFases: defineAsyncComponent(
    () => import("../components/ConfigurarFases.vue")
  ),
  ConfigurarEquipos: defineAsyncComponent(
    ()=> import("../components/ConfigurarEquipos.vue")
  ),
  ConfiguraPuntesProjects: defineAsyncComponent(
    ()=> import("../components/ConfiguraPuntesProjects.vue")
  ),
  ConfigurarListadoDatos: defineAsyncComponent(
    ()=> import("../components/ConfigurarListadoDatos.vue")
  ),
  ConfigurarEmailMateriales: defineAsyncComponent(
    ()=> import("../components/ConfigurarEmailMateriales.vue")
  ),
  ConfigurarEmailInicioTareasAsignadas: defineAsyncComponent(
    ()=> import("../components/ConfigurarEmailInicioTareasAsignadas.vue")
  ),
  ConfigurarEmailTareasAsignadas: defineAsyncComponent(
    ()=> import("../components/ConfigurarEmailTareasAsignadas.vue")
  ),
  ConfigurarEmailTareasAsignadasNuevosItems: defineAsyncComponent(
    () => import("../components/ConfigurarEmailTareasAsignadasNuevosItems.vue")
  ),
  ConfigurarEmailCambioCodigoMateriales: defineAsyncComponent(
    ()=> import("../components/ConfigurarEmailCambioCodigoMateriales.vue")
  ),
  ConfigurarEmailsTareasCompletadas: defineAsyncComponent(
    ()=> import("../components/ConfigurarEmailsTareasCompletadas.vue")
  ),
};
const goBack = () => {
  if (window.history.length > 2) {
    router.go(-1);
  } else {
    // Redirige a una ruta específica si no hay historial
    router.push('/');
  }
};
onMounted(async () => {
  await CommonStore.GetDatosMaestros()
});

return (_ctx: any,_cache: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { style: {"height":"50px !important"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_page_header, { onBack: goBack }, {
              content: _withCtx(() => _cache[11] || (_cache[11] = [
                _createElementVNode("span", { class: "text-large font-600 mr-3" }, " Configuración ", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_aside, { width: "220px" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu, {
                  router: "",
                  class: "el-menu-vertical"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveComponent('ConfigurarTareas')))
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createElementVNode("span", null, "Tareas", -1)
                      ])),
                      _: 1,
                      __: [12]
                    }),
                    _createVNode(_component_el_menu_item, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveComponent('ConfigurarFases')))
                    }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createElementVNode("span", null, "Fases", -1)
                      ])),
                      _: 1,
                      __: [13]
                    }),
                    _createVNode(_component_el_menu_item, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (setActiveComponent('ConfigurarEquipos')))
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createElementVNode("span", null, "Equipos", -1)
                      ])),
                      _: 1,
                      __: [14]
                    }),
                    _createVNode(_component_el_menu_item, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (setActiveComponent('ConfiguraPuntesProjects')))
                    }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createElementVNode("span", null, "Puntes Proyectos", -1)
                      ])),
                      _: 1,
                      __: [15]
                    }),
                    _createVNode(_component_el_sub_menu, null, {
                      title: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode("Configurar emails")
                      ])),
                      default: _withCtx(() => [
                        _createVNode(_component_el_menu_item, {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (setActiveComponent('ConfigurarEmailMateriales')))
                        }, {
                          default: _withCtx(() => _cache[17] || (_cache[17] = [
                            _createElementVNode("span", null, "Email materiales", -1)
                          ])),
                          _: 1,
                          __: [17]
                        }),
                        _createVNode(_component_el_menu_item, {
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (setActiveComponent('ConfigurarEmailInicioTareasAsignadas')))
                        }, {
                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createElementVNode("span", null, "Email inicio proyecto", -1)
                          ])),
                          _: 1,
                          __: [18]
                        }),
                        _createVNode(_component_el_menu_item, {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (setActiveComponent('ConfigurarEmailTareasAsignadas')))
                        }, {
                          default: _withCtx(() => _cache[19] || (_cache[19] = [
                            _createElementVNode("span", null, "Email tareas", -1)
                          ])),
                          _: 1,
                          __: [19]
                        }),
                        _createVNode(_component_el_menu_item, {
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (setActiveComponent('ConfigurarEmailCambioCodigoMateriales')))
                        }, {
                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createElementVNode("span", null, "Email cambio código", -1)
                          ])),
                          _: 1,
                          __: [20]
                        }),
                        _createVNode(_component_el_menu_item, {
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (setActiveComponent('ConfigurarEmailTareasAsignadasNuevosItems')))
                        }, {
                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createElementVNode("span", null, "Email tareas nuevo PA o material", -1)
                          ])),
                          _: 1,
                          __: [21]
                        }),
                        _createVNode(_component_el_menu_item, {
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (setActiveComponent('ConfigurarEmailsTareasCompletadas')))
                        }, {
                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createElementVNode("span", null, "Plantillas tareas completadas", -1)
                          ])),
                          _: 1,
                          __: [22]
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (setActiveComponent('ConfigurarListadoDatos')))
                    }, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createElementVNode("span", null, "Listados de datos", -1)
                      ])),
                      _: 1,
                      __: [23]
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(componentsMap[activeComponent.value])))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, userRoles.value.includes(_unref(Roles).Admin)]
    ])
  ]))
}
}

})